// extracted by mini-css-extract-plugin
export default {"item":"ColorBulletListItem_item__F5Gx+","bullet":"ColorBulletListItem_bullet__kdTdh"};